// src/components/pages/PlayerList.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import '../styles/PlayerList.css';  // Import the CSS for styling

const PlayerList = () => {
  const [players, setPlayers] = useState([]);
  const [newPlayerName, setNewPlayerName] = useState('');
  const [newPlayerSkill, setNewPlayerSkill] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch players on component mount
  useEffect(() => {
    setLoading(true);
    api.get('/api/players')
      .then(response => {
        setPlayers(response.data);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        if (error.response?.status === 401) {
          console.warn('Unauthorized — redirecting to login...');
          navigate('/login');
        } else {
          console.error("Error fetching players", error);
        }
      });
  }, [navigate]);

  const addPlayer = () => {
    if (!newPlayerName) return alert("Please enter a player's name!");
    const newPlayer = { name: newPlayerName, skillLevel: newPlayerSkill };

    api.post('/api/players', newPlayer)
      .then(response => {
        setPlayers([...players, response.data]);
        setNewPlayerName('');
        setNewPlayerSkill(1);
      })
      .catch(error => {
        if (error.response?.status === 401) {
          navigate('/login');
        } else {
          console.error("Error adding player", error);
        }
      });
  };

  const updateSkillLevel = (id, newSkillLevel) => {
    const playerToUpdate = players.find(player => player.id === id);
    if (!playerToUpdate) return;

    api.put(`/api/players/${id}`, {
      ...playerToUpdate,
      skillLevel: newSkillLevel
    })
      .then(response => {
        const updatedPlayers = players.map(player =>
          player.id === id ? response.data : player
        );
        setPlayers(updatedPlayers);
      })
      .catch(error => {
        if (error.response?.status === 401) {
          navigate('/login');
        } else {
          console.error("Error updating skill level", error);
        }
      });
  };

  const deletePlayer = (id) => {
    if (window.confirm("Are you sure you want to delete this player? This action cannot be reversed.")) {
      api.delete(`/api/players/${id}`)
        .then(() => {
          setPlayers(players.filter(player => player.id !== id));
        })
        .catch(error => {
          if (error.response?.status === 401) {
            navigate('/login');
          } else {
            console.error("Error deleting player", error);
          }
        });
    }
  };

  return (
    <div className="player-list-container">

      {/* Add Player Section */}
      <div className="add-player-form">
        <input
          type="text"
          value={newPlayerName}
          onChange={(e) => setNewPlayerName(e.target.value)}
          placeholder="Enter player name"
        />
        <select
          value={newPlayerSkill}
          onChange={(e) => setNewPlayerSkill(Number(e.target.value))}
        >
          {[...Array(10)].map((_, i) => (
            <option key={i} value={i + 1}>{i + 1}</option>
          ))}
        </select>
        <button onClick={addPlayer}>Add Player</button>
      </div>

      {/* Player List */}
      <div className="player-list">
        {loading ? <p>Loading players...</p> : (
          <ul>
            {players.map(player => (
              <li key={player.id} className="player-item">
                <span>{player.name}</span>
                <span>
                  <input
                    type="number"
                    value={player.skillLevel}
                    min="1"
                    max="10"
                    onChange={(e) => updateSkillLevel(player.id, Number(e.target.value))}
                  />
                </span>
                <button className="delete-btn" onClick={() => deletePlayer(player.id)}>Delete</button>
              </li>
            ))}
          </ul>
        )}
      </div>      
    </div>
  );
};

export default PlayerList;
